import { CashPlusRouteName, QueryParamsCollection } from "./../entities/cashplus.navigation.model";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router, UrlTree } from "@angular/router";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { CASH_PLUS } from "@helpers/constants";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class CashplusNavigationService {
	constructor(
		private router: Router,
		private universalModalService: UniversalModalService,
		private activatedRoute: ActivatedRoute
	) {}

	gotoByNavigationUrl(path: CashPlusRouteName, queryParams?: Partial<QueryParamsCollection>): void {
		const urlTree = this.gotoByUrlTree(path, queryParams);
		this.router.navigateByUrl(urlTree);
	}

	public closeModal(): void {
		this.universalModalService.close(ModalCloseReason.close);
	}

	routeParamsReader(): Observable<Partial<QueryParamsCollection>> {
		return this.activatedRoute.queryParams;
	}

	gotoByUrlTree(path: CashPlusRouteName, queryParams?: Partial<QueryParamsCollection>): UrlTree {
		return this.router.createUrlTree([{ outlets: { [ROUTER_OUTLET_NAME]: [CASH_PLUS, path] } }], {
			queryParams
		});
	}
}
